import { CInputText } from "./CInputText";
import { CInputPassword } from "./CInputPassword";
import { CToggle } from "./CToggle";
import { CMultiSelect } from "./CMultiSelect";
import { CSelect } from "./CSelect";
import { CInputTextArea } from "./CInputTextArea";

export {CInputText , CInputPassword , CToggle , CMultiSelect , CSelect , CInputTextArea}